import React from 'react';
import { useNavigate } from 'react-router-dom';
import FAQSection from '../components/ComingSoon/FAQSection';
import { categoryFaqs, categoryDisplayNames, Category } from '../data/faqData';

const FAQPage: React.FC = () => {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = React.useState<Category>('general');
  const [activeQuestionId, setActiveQuestionId] = React.useState<string | null>(null);
  const [viewedCategories, setViewedCategories] = React.useState<Set<Category>>(new Set());

  const getBackgroundColor = (category: Category): string => ({
    general: 'bg-[#F6BD60]',
    farm_advisory: 'bg-[#FAF0CA]',
    financial_services: 'bg-[#F5CAC3]',
    data_privacy: 'bg-[#F28482]'
  })[category];

  const handleCategoryView = (category: Category) => {
    setActiveCategory(category);
    setActiveQuestionId(null);
    setViewedCategories(prev => new Set(prev).add(category));
  };

  const toggleQuestion = (id: string) => {
    setActiveQuestionId(activeQuestionId === id ? null : id);
  };

  return (
    <FAQSection
      setVisibleSection={() => navigate('/home')}
      showSection={() => navigate('/waitlist')}
      categoryFaqs={categoryFaqs}
      activeCategory={activeCategory}
      toggleQuestion={toggleQuestion}
      activeQuestionId={activeQuestionId}
      categoryDisplayNames={categoryDisplayNames}
      getBackgroundColor={getBackgroundColor}
      handleCategoryView={handleCategoryView}
      setActiveQuestionId={setActiveQuestionId}
      viewedCategories={viewedCategories}
      customClassName={activeCategory === 'financial_services' ? 'pb-48' : ''} // Add extra spacing
    />
  );
};

export default FAQPage;
